<div>
    <app-position-template-list [organizationID]="data" [showVinterLogo]="1"></app-position-template-list>
<div>

<p-toast position="bottom-center"></p-toast>